export type ExperimentType = 'coin' | 'die';

export interface ExperimentDefinition {
  type: ExperimentType;
  label: string;
  outcomes: string[];
  targetOutcome: string;
  theoreticalProbability: number;
}

export interface TrialResult {
  trialSize: number;
  outcomeCounts: Record<string, number>;
  relativeFrequency: number;
}

export interface ProbabilityParams {
  experiment: ExperimentType;
  trialSizes: number[];
  targetOutcome?: string;
  seed?: string;
  showTable?: boolean;
  showChart?: boolean;
  editableTrialSizes?: boolean;
  chartHeight?: number;
  chartYAxisRange?: [number, number];
}

export const COIN_EXPERIMENT: ExperimentDefinition = {
  type: 'coin',
  label: 'Coin Flip',
  outcomes: ['Heads', 'Tails'],
  targetOutcome: 'Heads',
  theoreticalProbability: 0.5,
};

export const DIE_EXPERIMENT: ExperimentDefinition = {
  type: 'die',
  label: 'Die Roll',
  outcomes: ['1', '2', '3', '4', '5', '6'],
  targetOutcome: '6',
  theoreticalProbability: 1 / 6,
};

export const EXPERIMENT_MAP: Record<ExperimentType, ExperimentDefinition> = {
  coin: COIN_EXPERIMENT,
  die: DIE_EXPERIMENT,
};

export const DEFAULT_TRIAL_SIZES = [10, 20, 50, 100, 200, 500, 1000];

export const DEFAULT_PARAMS: ProbabilityParams = {
  experiment: 'coin',
  trialSizes: DEFAULT_TRIAL_SIZES,
  showTable: true,
  showChart: true,
  editableTrialSizes: true,
  chartHeight: 250,
  chartYAxisRange: [0.3, 0.7],
};
